export default __webpack_public_path__ + "static/media/pusheen.9b953407.jpg";